/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { UrlsService } from '../../services';

@Component({
  selector: 'app-successfully-verified',
  templateUrl: './successfully-verified.component.html',
  styleUrls: ['./successfully-verified.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuccessfullyVerifiedComponent {
  constructor(private readonly urlsService: UrlsService) {}

  revealUrl = this.urlsService.revealUrl;
}
